<mat-dialog-content>
        <div class="d-flex justify-content-between">
                <h5 class="fw-semibold">Brennstoffzellendetails </h5>
                <div class="d-flex">
                        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg"
                                alt="close-modal-icon" (click)="onCloseClicked()">
                </div>
        </div>
        <div class="d-flex flex-column ">
                <div>
                        <div class="w-100 d-flex justify-content-between gap-4"> <span> Systemzustand: </span>
                                <span>{{
                                        getSystemzustandString(systemzustand) }} </span>
                        </div>
                        <div class="w-100 d-flex justify-content-between gap-4"> <span> Ladezustand Batterie:</span>
                                <span> {{
                                        detailObj?.batteryLoad}}% </span>
                        </div>
                        <div class="w-100 d-flex justify-content-between gap-4"> <span> Batteriespannung:</span>
                                <span> {{
                                        detailObj?.batteryVoltage}} V</span>
                        </div>
                        <div class="w-100 d-flex justify-content-between gap-4"> <span> Generatorleistung:</span>
                                <span> {{
                                        detailObj?.generatorPower}} W</span>
                        </div>
                        <div class="w-100 d-flex justify-content-between gap-4"> <span> Generatorspannung: </span>
                                <span>{{
                                        detailObj?.generatorVoltage}} V</span>
                        </div>
                        <div class="w-100 d-flex justify-content-between gap-4"> <span> Generatorstrom:</span> <span>
                                        {{
                                        detailObj?.generatorCurrent }} A</span></div>
                        <div class="w-100 d-flex justify-content-between gap-4"> <span> Meldung Tanksensor:</span> <span> {{
                                        getJaNeinString(detailObj?.externalFuelSensorAlarm) }}</span></div>

                        <div class="w-100 d-flex justify-content-between gap-4"> <span> Aktive Patrone:</span> <span>
                                        {{
                                        detailObj?.nbActiveCart }}</span></div>

                        <div class="w-100 d-flex justify-content-between gap-4 "> <span> Füllstand Patrone 1:</span>
                                <span> {{
                                        detailObj?.fuelLevel?.[0] }}%</span>
                        </div>

                        <div class="w-100 d-flex justify-content-between gap-4"> <span> Füllstand Patrone 2:</span>
                                <span> {{
                                        detailObj?.fuelLevel?.[1] }}%</span>
                        </div>

                        <div *ngIf="details !== undefined">
                                <div class="w-100 d-flex justify-content-between gap-4"> <span> Systemzustand
                                                Detailliert:</span>
                                        <span> {{ getFuelCellSystemStateString(details.systemzustand) }}</span>
                                </div>
                                <div class="w-100 d-flex justify-content-between gap-4"> <span> Arbeitsmodus:</span>
                                        <span> {{ getArbeitsmodusString(details.arbeitsmodus) }}</span>
                                </div>
                                <div class="w-100 d-flex justify-content-between gap-4"> <span> Temperatur:</span>
                                        <span> {{ details.temperatur }}°C</span>
                                </div>
                                <div class="w-100 d-flex justify-content-between gap-4"> <span>
                                                Manuell an möglich:</span>
                                        <span> {{ getJaNeinString(details.manuellesSchaltenAnMoeglich) }}</span>
                                </div>
                                <div class="w-100 d-flex justify-content-between gap-4"> <span>
                                                Manuell aus möglich:</span>
                                        <span> {{ getJaNeinString(details.manuellesSchaltenAusMoeglich) }}</span>
                                </div>
                                <div class="w-100 d-flex justify-content-between gap-4"> <span>
                                                Letzter Ausschaltgrund:</span>
                                        <span> {{ getFuelCellSwitchOffReasonString(details.grundFuerAusschalten)
                                                }}</span>
                                </div>
                                <div class="w-100 d-flex justify-content-between gap-4"> <span>
                                                Letzter Einschaltgrund:</span>
                                        <span> {{ getFuelCellSwitchOnReasonString(details.grundFuerEinschalten)
                                                }}</span>
                                </div>
                                <div class="w-100 d-flex justify-content-between gap-4"> <span> Warncode:</span>
                                        <span> {{ getFuelCellCodeString(details.warncode) }}</span>
                                </div>
                                <div class="w-100 d-flex justify-content-between gap-4"> <span> Fehlercode:</span>
                                        <span> {{ getFuelCellCodeString(details.fehlercode) }}</span>
                                </div>
                                <div class="w-100 d-flex justify-content-between gap-4"> <span> Fehlercode
                                                Fuelmanager:</span>
                                        <span> {{ getFuelCellCodeString(details.fmFehlercode) }}</span>
                                </div>
                                <div class="w-100 d-flex justify-content-between gap-4"> <span>
                                                Betriebsstunden:</span>
                                        <span> {{ details.betriebsstunden }} Std.</span>
                                </div>
                                <div class="w-100 d-flex justify-content-between"> <span> Letzte Messung:</span>
                                        <span> {{ details.dateTime | date: 'dd.MM.yyyy H:mm'
                                                }} </span>
                                </div>
                        </div>
                        <div *ngIf="deviceInfo" class="mt-2 pt-2 border-top">
                                <div *ngIf="deviceInfo.deviceName" class="w-100 d-flex justify-content-between gap-4">
                                        <span> Gerätename:</span>
                                        <span> {{ deviceInfo.deviceName }}</span>
                                </div>
                                <div *ngIf="deviceInfo.serialNumber" class="w-100 d-flex justify-content-between gap-4">
                                        <span> Seriennummer:</span>
                                        <span> {{ deviceInfo.serialNumber }}</span>
                                </div>
                                <div *ngIf="deviceInfo.version" class="w-100 d-flex justify-content-between gap-4">
                                        <span> Version:</span>
                                        <span> {{ deviceInfo.version }}</span>
                                </div>
                        </div>
                </div>
        </div>
</mat-dialog-content>